/// <amd-module name="Build/Run/Components/RunSummaryBaseLinkComponent" />
import * as React from "react";

import { ITfsPageService } from "Tfs/Platform/Page";

import { FPSLink } from "VSS/Features/PlatformUI/FPSLink";
import { routeUrl } from "VSS/Platform/Location";
import { IVssPageContext } from "VSS/Platform/Context";
import { IVssComponentContext, VssComponent } from "VSS/Platform/Layout";
import { Icon } from "VSSUI/Icon";

const c_TelemetrySource = "RunSummary";

export interface IRunSummaryBaseLinkComponentProps {
    currentRunId: number;
    linkClassName: string;
    iconName: string;
    routeId: string;
    urlDisplayText: string;
    subtle?: boolean;
    linkDescribedBy?: string;
    telemetryProperties?: {[propertyName: string]: string};
}

const c_RouteParameters_Project = "project";
const c_RouteParameters_CurrentRunId = "currentRunId";

export class RunSummaryBaseLinkComponent extends VssComponent<IRunSummaryBaseLinkComponentProps> {
    constructor(props: IRunSummaryBaseLinkComponentProps, context: IVssComponentContext) {
        super(props, context);
    }

    public render() {

        //  Create route value and URL.
        const routeValues: { [key: string]: string } = {};
        this._initializeRouteValues(this.context.pageContext, routeValues);

        let url = routeUrl(this.context.pageContext, this.props.routeId, routeValues);

        return (
            <FPSLink
                supportsFPS={true}
                telemetryProperties={this.props.telemetryProperties || {}}
                telemetrySource={c_TelemetrySource}
                ariaDescribedBy={this.props.linkDescribedBy}
                className={this.props.linkClassName}
                href={url}
                subtle={this.props.subtle}
                removeUnderline={true}
            >
                <span className="text-ellipsis">
                    <Icon iconName={this.props.iconName} className="pipelines-icon-right-margin" />
                    {this.props.urlDisplayText}
                </span>
            </FPSLink>
        );
    }

    private _initializeRouteValues(pageContext: IVssPageContext, routeValues: { [key: string]: string }) {
        let projectName: string = "";

        const tfsPageService = pageContext.getService<ITfsPageService>("ITfsPageService");
        const tfsPageData = tfsPageService.getData();

        if (tfsPageData) {
            if (!projectName && tfsPageData.project) {
                projectName = tfsPageData.project.name;
            }
        }

        if (projectName) {
            routeValues[c_RouteParameters_Project] = projectName;
        }

        if (this.props.currentRunId) {
            routeValues[c_RouteParameters_CurrentRunId] = this.props.currentRunId.toString();
        }
    }
}
